import configData from "../config/config.json";

export const UrlImg = configData.UrlApi + "Upload/Images/PIP/";
export const UrlFoto = configData.UrlApi + "Upload/Images/Foto/";
